import React, { Component } from "react";
import { Switch, Route, Link } from "react-router-dom";
import Backicon from "../../../shared/components/Backicon/Backicon";
import styles from "./emergencyroutes.module.css";
import DoctorsNearby from "../DoctorsNearby/DoctorsNearby";
import Tile from "../../../shared/components/Tile/Tile";
import EmergencyAppointments from "../EmergencyAppointment/EmergencyAppointment";

class EmergencyRoutes extends Component {
    render() {
        return ( <
            div className = { styles.emergencybanner } >
            <
            Backicon onClick = {
                () => this.props.history.goBack()
            }
            /> <
            h1 > Emergency < /h1> <
            div className = { styles.tilestyle } >
            <
            Link to = "/emergency/doctors-nearby" >
            <
            Tile name = "Doctors Nearby"
            style = {
                {
                    height: "200px",
                    width: "250px",
                    fontSize: "2.5rem",
                    backgroundColor: "rgba(255, 255, 255, 0.619)",
                }
            }
            /> < /
            Link > <
            Link to = "/emergency/emergency-appointment" >
            <
            Tile name = "Emergency Appointment"
            style = {
                {
                    height: "200px",
                    width: "250px",
                    fontSize: "2.5rem",
                    backgroundColor: "rgba(255, 255, 255, 0.619)",
                }
            }
            /> < /
            Link > <
            /div> < /
            div >
        );
    }
}

function EmergencyRoute() {
    return ( <
        Switch >
        <
        Route path = "/emergency"
        exact component = { EmergencyRoutes }
        /> <
        Route path = "/emergency/doctors-nearby"
        component = { DoctorsNearby }
        /> <
        Route path = "/emergency/emergency-appointment"
        component = { EmergencyAppointments }
        /> < /
        Switch >
    );
}

export default EmergencyRoute;